import api from '@/utils/api';

/**
 * Update company option
 * @param {string} companyId - Company Id
 * @returns {Promise}
 */
const getCompanyOptionsByIdsApi =
  (companyId) => (optionIds, optionPriceLinkIds) =>
    api.post(`company/${companyId}/option/options-by-ids`, {
      optionIds,
      optionPriceLinkIds,
    });

export default getCompanyOptionsByIdsApi;
